import fileTypeToCustomValidationFunctionsDictionary from "components/Shared/MDropzone/utility/fileTypeToCustomValidationFunctionsDictionary";
import * as actionTypes from "components/Shared/MDropzone/utility/actionTypes";
import customValidation from "components/Shared/MDropzone/utility/customValidation";
import * as fileTypes from "components/Shared/MDropzone/utility/fileTypes";
import * as methodDefaults from "components/Shared/MDropzone/utility/methodDefaults";
import useDropzoneProperties from "components/Shared/MDropzone/utility/useDropzoneProperties";
import useExistingFiles from "components/Shared/MDropzone/utility/useExistingFiles";
import useParseValidFileTypes from "components/Shared/MDropzone/utility/useParseValidFileTypes";
import moment from "moment-timezone";

export const getFileKey = ({name, uploaded}) => `${name}-${uploaded}`;

export const getFileExtensionFromFileName = fileName => fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase();

export const getFileSizeString = fileSizeBytes => {
  if (!fileSizeBytes) return "";
  let i = 0;
  while (fileSizeBytes > 1024) {
    fileSizeBytes /= 1024;
    i++;
  }
  //1 gpb (Geopbyte) is 1,000,000,000,000,000,000,000,000,000,000 bytes. this is the most future proof code i have ever written
  return `${fileSizeBytes.toFixed(1)}${["b","kb","mb","gb","tb","pb","eb","zb","yb","bb","gpb"][i]}`;
};

export const parseExistingFiles = existingFiles =>
  existingFiles.map(({fileName, lastModified, downloadUrl, viewUrl, fileSizeBytes, ...rest}) => ({
    ...rest,
    lastModified: null,
    lastModifiedDate: lastModified,
    name: fileName,
    downloadUrl: downloadUrl,
    viewUrl: viewUrl,
    size: getFileSizeString(fileSizeBytes),
    type: null,
    webkitRelativePath: null,
    uploaded: lastModified,
    extension: getFileExtensionFromFileName(fileName),
    file: null,
  }));

export const parseAcceptedFiles = acceptedFiles => acceptedFiles.map(acceptedFile => ({
  lastModified: acceptedFile.lastModified,
  lastModifiedDate: acceptedFile.lastModifiedDate,
  name: acceptedFile.name,
  downloadUrl: acceptedFile.path,
  viewUrl: acceptedFile.path,
  size: acceptedFile.size,
  type: acceptedFile.type,
  webkitRelativePath: acceptedFile.webkitRelativePath,
  uploaded: moment().format(),
  extension: getFileExtensionFromFileName(acceptedFile.name),
  file: acceptedFile,
}));

export const parseValidFileType = validFileType =>
validFileType ? (
  typeof validFileType === "object" ? (
    validFileType.type
  ) : (
    validFileType
  )
) : (
null
);

export const parseValidFileTypes = validFileTypes => 
  Array.isArray(validFileTypes) ? (
    validFileTypes.map(parseValidFileType)
  ) : (
    parseValidFileType(validFileTypes)
  );

export const filterValidFileTypesByType = ({validFileTypes, type}) => Array.isArray(validFileTypes) ? (
  validFileTypes.find(validFileType => 
    parseValidFileType(validFileType) === type
  )
) : (
  parseValidFileType(validFileTypes) === type ? (
    validFileTypes
  ) : (
    undefined
  )
);

export {
  fileTypeToCustomValidationFunctionsDictionary,
  actionTypes,
  customValidation,
  fileTypes,
  methodDefaults,
  useDropzoneProperties,
  useExistingFiles,
  useParseValidFileTypes,
};